import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { HeaderComponent } from '../../components/header/header.component';
import { MenuModel } from '../../models/common/menu.model';
import { MAIN_MENU } from '../../constants/menu';
import { USER_RESTRICTED_PATHS } from '../../constants/restricted-path';
import { SidebarService } from '../../services/sidebar.service';
import { AuthenticationService } from '../../services/authentication.service';
import { ProcessLoadingService } from '../../services/loading.service';
import { MapService } from '../../services/map.service';
import { MapInfo } from '../../models/mapinfo.model';
import { ROUTE_PATH } from '../../constants/route-path';
import { AccountManagementService } from '../../services/account-management.service';
import { SessionStorageKey } from '../../constants/session-storage-key';
import { TEXT_COMMON } from '../../constants/text';


@Component({
  selector: 'careposi-main-layout',
  standalone: true,
  imports: [RouterOutlet, SidebarComponent, HeaderComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  sidebarExpanded: boolean = false;
  sidebarMenu: MenuModel[] = MAIN_MENU;
  @Output() toggleSidebar = new EventEmitter();
  lstMapManager: MapInfo[] = [];

  constructor(private sidebarService: SidebarService,
    private auth: AuthenticationService,
    private accountService: AccountManagementService,
    private mapService: MapService,
    private processLoadingService: ProcessLoadingService) {
    
  }
  ngOnInit(): void {
    this.LoadSidebarMenu();
    this.sidebarService.setMinMaxWidth(64, 240);
    this.getMenuWithUserRole();
  }
  handleToggleSidebar(value: any) {
    this.sidebarExpanded = value;
    this.toggleSidebar.emit(value);
  }
  handleToggleSidebarComplete() {

  }
  LoadSidebarMenu(){
    this.mapService.lstMapManager.subscribe((data) => {
      this.lstMapManager = data || [];
      if (this.lstMapManager.length == 0) {
        this.sidebarMenu = MAIN_MENU;
      } else {
        let manumap = {
          title: 'マップ',
          path: ROUTE_PATH.MAP,
          icon: 'images/icon/menu/map-marker-animated.svg',
          routerLink: '',
          children: [] as MenuModel[]
        };
        this.lstMapManager.sort((a, b) => (a?.mid || "").localeCompare(b?.mid || "")).forEach((map: MapInfo) => { 
          const mapChildren: MenuModel[] = [];
          map.listfloor?.forEach((floor) => {
            mapChildren.push({
              title: floor.fname || 'マップ',
              path: `${ROUTE_PATH.MAP}/${map.mid}/${floor.floorid}`,
              icon: 'images/icon/menu/map-active.svg',
              routerLink: ''
            });
          });

          manumap.children?.push({
              title: TEXT_COMMON.ALL_MAP_NAME,
              path: `${ROUTE_PATH.MAP}/${map.mid}`,
              icon: 'images/icon/menu/map-active.svg',
              routerLink: '',
              children: mapChildren
          })
        });
        this.sidebarMenu = [manumap, ...MAIN_MENU]
      }

    });
  }

  getMenuWithUserRole(){
    const userId = this.auth.getCurrentUserValue()?.userId?.toString() || '';
    const companyId = this.auth.getCompanyId()?.toString() || '';
    this.accountService.getUserRole(userId, companyId).subscribe(result => {
      if(result){
        this.sidebarMenu = this.filterMenuByRole(this.sidebarMenu, result);
      }
    });
  }

  filterMenuByRole(menus: MenuModel[], role: string): MenuModel[] {
    const menuClone: MenuModel[] = JSON.parse(JSON.stringify(menus));
    if (role !== 'USER') {
      return menuClone;
    }
    return menuClone.map(menu => {
      if (menu.path !== ROUTE_PATH.SETTINGS || !menu.children) {
        return menu;
      }

      return {
        ...menu,
        children: menu.children.filter(child =>
          !USER_RESTRICTED_PATHS.some(restricted =>
            child.path?.includes(restricted)
          )
        )
      };
    });
  }

  async handleLogout() {
    this.processLoadingService.showLoading();
    await this.auth.logout();
    sessionStorage.removeItem(SessionStorageKey.OFFICES)
    sessionStorage.removeItem(SessionStorageKey.ORGANIZATION)
    this.processLoadingService.hideLoading();
  }
}
